<template>
  <CFooter :fixed="false" style="background-color:#BFBFBF;">
    <div>
      Institut Akuntan Publik Indonesia © {{new Date().getFullYear()}}. All Rights Reserved.
    </div>
    <div class="ml-auto">
      <span class="mr-1">Developed by</span>
      <a href="#" target="_blank">Divisi IT IAPI</a>
    </div>
  </CFooter>
</template>
<script>
export default {
  name: 'TheFooter'
}
</script>
